import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { Subject, Observable, lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';

export interface TeamInfo {
  id: string;
  name: string;
  slug: string;
  description: string;
  members: string[];
  agent_ids: string[];
}

export type TeamConfig = {
  orchestrator: { [key: string]: any };
  path: { [key: string]: string };
  services: string[];
};

@Injectable({ providedIn: 'root' })
export class TeamsService {
  private _save$: Subject<any> = new Subject();
  private _delete$: Subject<any> = new Subject();

  public list: TeamInfo[] = [];
  private _collection$: Subject<TeamInfo[]> = new Subject();
  get collection$() {
    return this._collection$.asObservable();
  }

  constructor(private http: HttpClient) {
    window.$teams = this;
  }

  public load(): Observable<TeamInfo[]> {
    this.http.get<TeamInfo[]>(`${ConfigService.muxUrl}/organizations`).subscribe((teams) => {
      this._collection$.next(teams);
      this.list = teams;
    });
    return this._collection$.asObservable();
  }

  public save(team: any): Observable<any> {
    return this.http.post(`${ConfigService.muxUrl}/organizations`, team);
  }

  public update(orgId: string, data: { name?: string; description?: string }): Observable<TeamInfo> {
    return this.http.patch<TeamInfo>(`${ConfigService.muxUrl}/organizations/${orgId}`, data);
  }

  public delete(orgId: string): Observable<any> {
    this.http.delete(`${ConfigService.muxUrl}/organizations/${orgId}`).subscribe(
      () => {
        this._delete$.next(true);
        this.load();
      },
      (error: any) => console.error(error)
    );
    return this._delete$.asObservable();
  }

  public async getConfigAsync(teamName: string) {
    return lastValueFrom(this.http.get<TeamConfig>(`${ConfigService.apiUrl}/team/config/${teamName}`));
  }
}
